export const BACKGROUND_TASKS_FLAG = 'DSN-922-background-task-progress'

export const BACKGROUND_TASK_KINDS = {
  EXPORT_PDF: 'export-pdf',
  EXPORT_IMAGE: 'export-image',
  EXPORT_EXCEL: 'export-excel',
}

// Untranslated keys: translated at render time so a mid-task language switch re-labels the card.
export const BACKGROUND_TASK_COPY = {
  [BACKGROUND_TASK_KINDS.EXPORT_PDF]: {
    extension: 'pdf',
    iconName: 'system-file-pdf',
    runningCaption: 'Preparing your PDF…',
    failedDescription: 'Couldn’t create your PDF.',
  },
  [BACKGROUND_TASK_KINDS.EXPORT_IMAGE]: {
    extension: 'zip',
    iconName: 'system-file',
    runningCaption: 'Preparing your images…',
    failedDescription: 'Couldn’t create your images.',
  },
  [BACKGROUND_TASK_KINDS.EXPORT_EXCEL]: {
    extension: 'xlsx',
    iconName: 'system-file-xls',
    runningCaption: 'Generating report…',
    failedDescription: 'Couldn’t create your report.',
  },
}

export const EXPORT_TYPE_TO_BACKGROUND_TASK_KIND = {
  pdf: BACKGROUND_TASK_KINDS.EXPORT_PDF,
  image: BACKGROUND_TASK_KINDS.EXPORT_IMAGE,
  excel: BACKGROUND_TASK_KINDS.EXPORT_EXCEL,
}

export const RATED_CARD_DISMISS_DELAY_MS = 1200
